"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rpcUrls = exports.envNetworks = exports.contractAddrs = exports.GRACE_PERIOD_SECONDS = exports.ETH_COIN_TYPE_LIST = exports.AUCTION_PERIOD_SECONDS = void 0;
var contractAddrs = {
  "dev": {
    "5": {
      "registarAddr": "0x9001FE87c9Dff82abF62F58bd57F8Ad32eD4bBbF",
      "managerAddr": "0x04D4532f31c1e9A5C4954d1755956C1FE06313f6",
      "registryEndPointAddr": "0x979be2099623090205e84cA1F0dc15c42bc5DBC8",
      "registryCoreAddr": "0xC5227CDC006D10DdCBDbf70cfedE36b337e8cE29",
      "defaultResolverAddr": "0xA6296802949E8d0d77f97bfaadF71649EAe74dDD",
      "layerZeroManagerAddr": "0x642F0C67b377BF17aCd80096E41BaC1a42453Fc0",
      "chainlinkAddr": "0xD4a33860578De61DBAbDc8BFdb98FD742fA7028e"
    },
    "97": {
      "registarAddr": "0xE21F0a50Dbae878b9808b98Ac5773bBB242b55E3",
      "managerAddr": "0xB54cFAF90bb27B4df566D8492366feaf6208D464",
      "registryEndPointAddr": "0xeBE730b9fc168726CC977057B4363F99d4F22bB4",
      "registryCoreAddr": "0x61dd8c37A6f6a7C5b6361d60Af6AcdAD87A0EB26",
      "defaultResolverAddr": "0x09022b9539DB10E9b191426e50951Cb2cF8b7733",
      "layerZeroManagerAddr": "0x5675Fb5e0356d39Cff0ee30e6ee47587b55e4A0C",
      "chainlinkAddr": "0x2514895c72f50D8bd4B4F9b1110F0D6bD2c97526"
    },
    "280": {
      "registarAddr": "0x96886Fb1e11412559f02a3ca027B03b5E71D5149",
      "managerAddr": "0x972789cBb635F65F6b0B8B1299b071cF373f3804",
      "registryEndPointAddr": "0x2c81cb86b4C59C25002A21576cf3E9B67a3D451B",
      "registryCoreAddr": "0x0F3e8336F50f15344C509786C3E9bf9a490eB26F",
      "defaultResolverAddr": "0xaE2bDF7cEc85E32cf0f0d0DfC9193B3F8355717D",
      "layerZeroManagerAddr": "0x3bDd5bd7FbAB5a545D207acccB34F7C6A146D55d",
      "chainlinkAddr": ""
    },
    "420": {
      "registarAddr": "0xa54AAcC4E94006D32B607A00744d3b8Ca00C10fE",
      "managerAddr": "0x4CAF953FA209b8e38cD6B459bDb60b77527381b7",
      "registryEndPointAddr": "0x7de60F28A2cB050038433C06E20104ccDBAdB961",
      "registryCoreAddr": "0x54858CCEFaaC97838FD295Afe683FA1dfc9C5dd7",
      "defaultResolverAddr": "0xBC7670DEf6a6dfABC64174D2c93aC9916970Ee8f",
      "layerZeroManagerAddr": "0x7c12237CBB3fad65ED1E99398D06aeB51AE054E6",
      "chainlinkAddr": "0x57241A37733983F97C4Ab06448F244A1E0Ca0ba8"
    },
    "80001": {
      "registarAddr": "0x29209653ee516C6775D570894a858A9A19701868",
      "managerAddr": "0x36E16B14f76273cEd00a99861Fe4ad8A421Af424",
      "registryEndPointAddr": "0x2B74E6d371CDEfF84e64FCACCfeCda8FE0D94118",
      "registryCoreAddr": "0x3A4c5297902DBD4460b7eC7AAF4b03Ca14590571",
      "defaultResolverAddr": "0x8D2595418b03ca53D1dfa9d1e2969d9EB1aEB890",
      "layerZeroManagerAddr": "0xe926F32c8D5acEd69B820dfAC71EDEef8aC705E1",
      "chainlinkAddr": "0xd0D5e3DB44DE05E9F294BB0a3bEEaF030DE24Ada"
    },
    "84531": {
      "registarAddr": "0x09Ff674F231D6e8dECd99E0a37d550E523186917",
      "managerAddr": "0xd52a2fB8eBBcd8378A645F9885721EdEB9d7EB17",
      "registryEndPointAddr": "0xe2AC90aE774D87510eb3EbC1bCd7C22b73276288",
      "registryCoreAddr": "0x145D163F024f5Cd12E29C96CB6e39D2C313d0BD9",
      "defaultResolverAddr": "0x0E3d1Fcefef30355B85Ec48E26d92731B28bB53b",
      "layerZeroManagerAddr": "0x87b957f2d32Fe2E331504adDAE928c12fF1F145D",
      "chainlinkAddr": "0xcD2A119bD1F7DF95d706DE6F2057fDD45A0503E2"
    },
    "421613": {
      "registarAddr": "0x226010bD99D98067a867943C39cafaecb8BBa485",
      "managerAddr": "0x7fB711611f144321E042240c7892D1840f135207",
      "registryEndPointAddr": "0x70c5f476b049D4bee065B721c961F85cBCD287d5",
      "registryCoreAddr": "0x02E5361CCFA89bCbA62FD560cddf9B63Cfd69d95",
      "defaultResolverAddr": "0x6F901F9ddeC9c0eec0cf327cc253D5a240241194",
      "layerZeroManagerAddr": "0x8b772B0ced53c5115c0F32d67e44Eb37C0cC538F",
      "chainlinkAddr": "0x62CAe0FA2da220f43a51F86Db2EDb36DcA9A5A08"
    },
    "59140": {
      "registarAddr": "0xAA837e07Bfc371169b347e3c749a56971087E2c5",
      "managerAddr": "0x71cA95beAc625Aefac44C0E1559B472306E9a500",
      "registryEndPointAddr": "0x4e84A193318908ecbC5a7A81105b36fd244f542C",
      "registryCoreAddr": "0x91F0EdCa938d4232eAdF3cbd057869B27003934F",
      "defaultResolverAddr": "0xc3DFbAfEB080b6d8A683e8bf0387Ba106733E90a",
      "layerZeroManagerAddr": "0xCfe25d36Beb66A21E5526DBaA578D26BF361c21B",
      "chainlinkAddr": ""
    },
    "1442": {
      "registarAddr": "0xc73808CA1300203903c2E985B7D66FBAeDB3F74b",
      "managerAddr": "0x2Bc1d9d6c5c903429f12d82F7064cE7a75Ad1A87",
      "registryEndPointAddr": "0x373663693a237d6662E7A6030Bcd25465F75b94e",
      "registryCoreAddr": "0x621e8Cd34f68dDA2177fBdF5E03d099602485e07",
      "defaultResolverAddr": "0xD7FA3DFa85b04526fa0C3ee4Eff6245D7B29227D",
      "layerZeroManagerAddr": "0x35937Fc123BaF7E13fD54F8E8639A15014d87c6F",
      "chainlinkAddr": ""
    },
    "43113": {
      "registarAddr": "0xB3D11aF7A264c48A343c99d3cdD175748E84EA2c",
      "managerAddr": "0xCfe0244685746a76c0dcf4a116b90417f81f329e",
      "registryEndPointAddr": "0x197f7266abF65B688A314aD09B440E051bC62048",
      "registryCoreAddr": "0x95A09744F0D178C55b5bF1F40C29c8DD5712F5B3",
      "defaultResolverAddr": "0x821cf32a4e3457BcACf460aF089D64ECB52C5596",
      "layerZeroManagerAddr": "0xbe0608Ca945b4514dCA994E23c94D16DFC0bc24B",
      "chainlinkAddr": "0x5498BB86BC934c8D34FDA08E81D444153d0D06aD"
    },
    "5611": {
      "registarAddr": "0xc230FAEbED018837e057cBB72158B3B65D8352Db",
      "managerAddr": "0xFA289Cd00a6fB9207754b856f8644cf3580d2e5e",
      "registryEndPointAddr": "0x0Bc96e64Eb9Ab9944b2f95dcD7b624AC22faeFE8",
      "registryCoreAddr": "0x6EcDa16fdAabE41D095ef2Ee57D29882365A1157",
      "defaultResolverAddr": "0xBa6F623f85ae7514a036e4745fD821282E4Ae65C",
      "layerZeroManagerAddr": "0x1695ad0b804FAc32B14815ee3b5ff9eA19336CeD",
      "chainlinkAddr": ""
    },
    "4002": {
      "registarAddr": "0x3A97e29994d5BFACa9a130F89072Cacc2022e998",
      "managerAddr": "0x6EcDa16fdAabE41D095ef2Ee57D29882365A1157",
      "registryEndPointAddr": "0x7818127930aD5Ed9E83DF535D9bF9cbb7439F034",
      "registryCoreAddr": "0x741EF6bB7152DE81C817664d0e0AEfc1437E9ab7",
      "defaultResolverAddr": "0xc230FAEbED018837e057cBB72158B3B65D8352Db",
      "layerZeroManagerAddr": "0x0Bc96e64Eb9Ab9944b2f95dcD7b624AC22faeFE8",
      "chainlinkAddr": "0xe04676B9A9A2973BCb0D1478b5E1E9098BBB7f3D"
    },
    "534351": {
      "registarAddr": "0xdde1628aB13460e3870E00EEc37782E1710593C3",
      "managerAddr": "0xb0e16eb2ca8aaa2267d2c5c55F999979444b2723",
      "registryEndPointAddr": "0x8d6fF08996083CFB68b5E8C8DFe0d773C3C2265d",
      "registryCoreAddr": "0x4d6FF88dd93b1911D2e61FA4Bbd8879cC57810dE",
      "defaultResolverAddr": "0x762db8903cc1E571Bd409D3e3a768Fc778607ebD",
      "layerZeroManagerAddr": "0xe03Ad88156aA136A266C9f8aae8Ef89720236844",
      "chainlinkAddr": "0x59F1ec1f10bD7eD9B938431086bC1D9e233ECf41"
    },
    "71": {
      "registarAddr": "0x612dE1447a90B48719EB555E79D2b54E8118befA",
      "managerAddr": "0x985f5cB36Aff58092A0d7b95c36EDA8BBBE6a0a8",
      "registryEndPointAddr": "0xb1C2ad11fEa06C2CeDc2D27052D537686FF9e3c0",
      "registryCoreAddr": "0xdeDc71aa77080524188396cC0EB2960e86E037E2",
      "defaultResolverAddr": "0xeD63Fadc828f59f907Bb9Bd32ea1D3001cC4C719",
      "layerZeroManagerAddr": "0x0d22e16fa41924C58F470294f640ca5417bD474B",
      "chainlinkAddr": ""
    },
    "5001": {
      "registarAddr": "0x8d6fF08996083CFB68b5E8C8DFe0d773C3C2265d",
      "managerAddr": "0x762db8903cc1E571Bd409D3e3a768Fc778607ebD",
      "registryEndPointAddr": "0xb0e16eb2ca8aaa2267d2c5c55F999979444b2723",
      "registryCoreAddr": "0xdde1628aB13460e3870E00EEc37782E1710593C3",
      "defaultResolverAddr": "0xe03Ad88156aA136A266C9f8aae8Ef89720236844",
      "layerZeroManagerAddr": "0x14bfDC548b1e64Efd7E9b4b35BE8f8b94096d740",
      "chainlinkAddr": ""
    },
    "3441005": {
      "registarAddr": "0x8d6fF08996083CFB68b5E8C8DFe0d773C3C2265d",
      "managerAddr": "0x762db8903cc1E571Bd409D3e3a768Fc778607ebD",
      "registryEndPointAddr": "0xb0e16eb2ca8aaa2267d2c5c55F999979444b2723",
      "registryCoreAddr": "0xdde1628aB13460e3870E00EEc37782E1710593C3",
      "defaultResolverAddr": "0xe03Ad88156aA136A266C9f8aae8Ef89720236844",
      "layerZeroManagerAddr": "0x14bfDC548b1e64Efd7E9b4b35BE8f8b94096d740",
      "chainlinkAddr": ""
    },
    "44787": {
      "registarAddr": "0x01b4F12B2C05E2d7dD10cc861795dC084C1AaC58",
      "managerAddr": "0xd3493a14282871d9F625076AB7802a7405A116A9",
      "registryEndPointAddr": "0x1dDDb55B9f04EDd2822CFf77727A985C814d33Db",
      "registryCoreAddr": "0xc6438aD72Cf80CCe4c6831C093dcEaA42CD95d8C",
      "defaultResolverAddr": "0xC8Bb48Fd3568352C4AA6169D52aa042BD48702a5",
      "layerZeroManagerAddr": "0x76E0c67a11Ee38C8ED6321F7FD5e122F076df535",
      "chainlinkAddr": "0x022F9dCC73C5Fb43F2b4eF2EF9ad3eDD1D853946"
    }
  },
  "test": {
    "11155111": {
      "registarAddr": "0x76E0c67a11Ee38C8ED6321F7FD5e122F076df535",
      "managerAddr": "0xC292bcBdF4722E2033310C667d3016CEc9e12DF0",
      "registryEndPointAddr": "0x11e78296491d0fC071dEFa690DDBE023484Dc590",
      "registryCoreAddr": "0xC8Bb48Fd3568352C4AA6169D52aa042BD48702a5",
      "defaultResolverAddr": "0x1c61252b067896438f7Fc53DB9C8d145D8B8789f",
      "layerZeroManagerAddr": "0x85c1584155182F58d55B5d16735ccfeFA1f08469",
      "chainlinkAddr": "0x694AA1769357215DE4FAC081bf1f309aDC325306"
    },
    "97": {
      "registarAddr": "0x373663693a237d6662E7A6030Bcd25465F75b94e",
      "managerAddr": "0xD7FA3DFa85b04526fa0C3ee4Eff6245D7B29227D",
      "registryEndPointAddr": "0x2Bc1d9d6c5c903429f12d82F7064cE7a75Ad1A87",
      "registryCoreAddr": "0xc73808CA1300203903c2E985B7D66FBAeDB3F74b",
      "defaultResolverAddr": "0x35937Fc123BaF7E13fD54F8E8639A15014d87c6F",
      "layerZeroManagerAddr": "0xE963E9f5c9B8b0F54f35A1B5BFE9d17df558d74B",
      "chainlinkAddr": "0x2514895c72f50D8bd4B4F9b1110F0D6bD2c97526"
    },
    "280": {
      "registarAddr": "0x1dea04DF6EB2F1a899D54603DE8087595c726158",
      "managerAddr": "0x1CBB2d5e2a31933f2A2Fc827f162cBb276d76ECA",
      "registryEndPointAddr": "0xE0668eB79a22af2130E92C2e66067E51CB09F977",
      "registryCoreAddr": "0x686FaC3179fF0320DD110D408f292568a5d64cf9",
      "defaultResolverAddr": "0x639cbc018EbF85c106F9D3E1161f654F88bAB703",
      "layerZeroManagerAddr": "0xC342171206eD08773f32E6BD1A377f72dD5F05f0",
      "chainlinkAddr": ""
    },
    "11155420": {
      "registarAddr": "0x01b4F12B2C05E2d7dD10cc861795dC084C1AaC58",
      "managerAddr": "0xd3493a14282871d9F625076AB7802a7405A116A9",
      "registryEndPointAddr": "0x1dDDb55B9f04EDd2822CFf77727A985C814d33Db",
      "registryCoreAddr": "0xc6438aD72Cf80CCe4c6831C093dcEaA42CD95d8C",
      "defaultResolverAddr": "0xC8Bb48Fd3568352C4AA6169D52aa042BD48702a5",
      "layerZeroManagerAddr": "0x76E0c67a11Ee38C8ED6321F7FD5e122F076df535",
      "chainlinkAddr": "0x61Ec26aA57019C486B10502285c5A3D4A4750AD7"
    },
    "80001": {
      "registarAddr": "0x354BB4198C5CeEd5173A15F1576Ae7772ACDaC15",
      "managerAddr": "0x95A09744F0D178C55b5bF1F40C29c8DD5712F5B3",
      "registryEndPointAddr": "0x2ddFBA08e8d7C9Be45f705bf05f11c0Efc49ED44",
      "registryCoreAddr": "0x10BBf8AaD4DEa292693c137942C9BB7aF199e506",
      "defaultResolverAddr": "0xB3D11aF7A264c48A343c99d3cdD175748E84EA2c",
      "layerZeroManagerAddr": "0x197f7266abF65B688A314aD09B440E051bC62048",
      "chainlinkAddr": "0xd0D5e3DB44DE05E9F294BB0a3bEEaF030DE24Ada"
    },
    "84532": {
      "registarAddr": "0xcc8734cc0A9b2B460caC997730401f614FE36c36",
      "managerAddr": "0x87784286B9Cf094382C3048C1F41e973EDC7a06a",
      "registryEndPointAddr": "0x207cE423Cade3f945b963ffAe15BE40E7eE30922",
      "registryCoreAddr": "0x1fa59909ec3bD740B1cAC991d0C3d95EeF2fCF4c",
      "defaultResolverAddr": "0x20Eee81481faF84C872a131d19323188aa417045",
      "layerZeroManagerAddr": "0xCb5eEC95402E4dd34B99D536a6b401fEf3EF7A40",
      "chainlinkAddr": "0x4aDC67696bA383F43DD60A9e78F2C97Fbbfc7cb1"
    },
    "421614": {
      "registarAddr": "0x01b4F12B2C05E2d7dD10cc861795dC084C1AaC58",
      "managerAddr": "0xd3493a14282871d9F625076AB7802a7405A116A9",
      "registryEndPointAddr": "0x1dDDb55B9f04EDd2822CFf77727A985C814d33Db",
      "registryCoreAddr": "0xc6438aD72Cf80CCe4c6831C093dcEaA42CD95d8C",
      "defaultResolverAddr": "0xC8Bb48Fd3568352C4AA6169D52aa042BD48702a5",
      "layerZeroManagerAddr": "0x76E0c67a11Ee38C8ED6321F7FD5e122F076df535",
      "chainlinkAddr": "0xd30e2101a97dcbAeBCBC04F14C3f624E67A35165"
    },
    "59140": {
      "registarAddr": "0xc73808CA1300203903c2E985B7D66FBAeDB3F74b",
      "managerAddr": "0x2Bc1d9d6c5c903429f12d82F7064cE7a75Ad1A87",
      "registryEndPointAddr": "0x373663693a237d6662E7A6030Bcd25465F75b94e",
      "registryCoreAddr": "0x621e8Cd34f68dDA2177fBdF5E03d099602485e07",
      "defaultResolverAddr": "0xD7FA3DFa85b04526fa0C3ee4Eff6245D7B29227D",
      "layerZeroManagerAddr": "0x35937Fc123BaF7E13fD54F8E8639A15014d87c6F",
      "chainlinkAddr": ""
    },
    "1442": {
      "registarAddr": "0x741EF6bB7152DE81C817664d0e0AEfc1437E9ab7",
      "managerAddr": "0x7818127930aD5Ed9E83DF535D9bF9cbb7439F034",
      "registryEndPointAddr": "0x3A97e29994d5BFACa9a130F89072Cacc2022e998",
      "registryCoreAddr": "0x0Bc96e64Eb9Ab9944b2f95dcD7b624AC22faeFE8",
      "defaultResolverAddr": "0x6EcDa16fdAabE41D095ef2Ee57D29882365A1157",
      "layerZeroManagerAddr": "0xc230FAEbED018837e057cBB72158B3B65D8352Db",
      "chainlinkAddr": ""
    },
    "43113": {
      "registarAddr": "0x4d41D1fDcE51C31fAa4983bB1Ba063A695406838",
      "managerAddr": "0x4d518a5bf9d659FAD688BA08cA1e035a7c6b8765",
      "registryEndPointAddr": "0xC210bbc45B0b10099300677ac455BE10184d0362",
      "registryCoreAddr": "0xCf595036B9408B981342d6bd24E745237882D58D",
      "defaultResolverAddr": "0x200Dd1AB1901300F4DcD947d4332220312905555",
      "layerZeroManagerAddr": "0xfCb39E390bEBfF39A8AFBEf72AFaD2a4810e7161",
      "chainlinkAddr": "0x5498BB86BC934c8D34FDA08E81D444153d0D06aD"
    },
    "5611": {
      "registarAddr": "0xEA48FA5Beb8497D4fb4B319FfC772f6B1f4A5B53",
      "managerAddr": "0xfA4A5B6158f3AA61D9b03A124FA6073265e4dac0",
      "registryEndPointAddr": "0x2B333FF0a3e5A4d79B058aA91F2EC03E051EB469",
      "registryCoreAddr": "0xc0337aC03a2F1A9c01a7BAD5B503f1C978B36f53",
      "defaultResolverAddr": "0x45B4Ff81c758624872FC36c67a3EAC82Ac2de64c",
      "layerZeroManagerAddr": "0x177a6bbB6a322c17a67c6AfDB558923FAEF6480e",
      "chainlinkAddr": ""
    },
    "4002": {
      "registarAddr": "0x01b4F12B2C05E2d7dD10cc861795dC084C1AaC58",
      "managerAddr": "0xd3493a14282871d9F625076AB7802a7405A116A9",
      "registryEndPointAddr": "0x1dDDb55B9f04EDd2822CFf77727A985C814d33Db",
      "registryCoreAddr": "0xc6438aD72Cf80CCe4c6831C093dcEaA42CD95d8C",
      "defaultResolverAddr": "0xC8Bb48Fd3568352C4AA6169D52aa042BD48702a5",
      "layerZeroManagerAddr": "0x76E0c67a11Ee38C8ED6321F7FD5e122F076df535",
      "chainlinkAddr": "0xe04676B9A9A2973BCb0D1478b5E1E9098BBB7f3D"
    },
    "534351": {
      "registarAddr": "0x01b4F12B2C05E2d7dD10cc861795dC084C1AaC58",
      "managerAddr": "0xd3493a14282871d9F625076AB7802a7405A116A9",
      "registryEndPointAddr": "0x1dDDb55B9f04EDd2822CFf77727A985C814d33Db",
      "registryCoreAddr": "0xc6438aD72Cf80CCe4c6831C093dcEaA42CD95d8C",
      "defaultResolverAddr": "0xC8Bb48Fd3568352C4AA6169D52aa042BD48702a5",
      "layerZeroManagerAddr": "0x76E0c67a11Ee38C8ED6321F7FD5e122F076df535",
      "chainlinkAddr": "0x59F1ec1f10bD7eD9B938431086bC1D9e233ECf41"
    },
    "71": {
      "registarAddr": "0x01b4F12B2C05E2d7dD10cc861795dC084C1AaC58",
      "managerAddr": "0xd3493a14282871d9F625076AB7802a7405A116A9",
      "registryEndPointAddr": "0x1dDDb55B9f04EDd2822CFf77727A985C814d33Db",
      "registryCoreAddr": "0xc6438aD72Cf80CCe4c6831C093dcEaA42CD95d8C",
      "defaultResolverAddr": "0xC8Bb48Fd3568352C4AA6169D52aa042BD48702a5",
      "layerZeroManagerAddr": "0x76E0c67a11Ee38C8ED6321F7FD5e122F076df535",
      "chainlinkAddr": ""
    },
    "5003": {
      "registarAddr": "0x01b4F12B2C05E2d7dD10cc861795dC084C1AaC58",
      "managerAddr": "0xd3493a14282871d9F625076AB7802a7405A116A9",
      "registryEndPointAddr": "0x1dDDb55B9f04EDd2822CFf77727A985C814d33Db",
      "registryCoreAddr": "0xc6438aD72Cf80CCe4c6831C093dcEaA42CD95d8C",
      "defaultResolverAddr": "0xC8Bb48Fd3568352C4AA6169D52aa042BD48702a5",
      "layerZeroManagerAddr": "0x76E0c67a11Ee38C8ED6321F7FD5e122F076df535",
      "chainlinkAddr": ""
    },
    "3441006": {
      "registarAddr": "0x01b4F12B2C05E2d7dD10cc861795dC084C1AaC58",
      "managerAddr": "0xd3493a14282871d9F625076AB7802a7405A116A9",
      "registryEndPointAddr": "0x1dDDb55B9f04EDd2822CFf77727A985C814d33Db",
      "registryCoreAddr": "0xc6438aD72Cf80CCe4c6831C093dcEaA42CD95d8C",
      "defaultResolverAddr": "0xC8Bb48Fd3568352C4AA6169D52aa042BD48702a5",
      "layerZeroManagerAddr": "0x0000000000000000000000000000000000000000",
      "chainlinkAddr": ""
    },
    "44787": {
      "registarAddr": "0xdde1628aB13460e3870E00EEc37782E1710593C3",
      "managerAddr": "0xb0e16eb2ca8aaa2267d2c5c55F999979444b2723",
      "registryEndPointAddr": "0x8d6fF08996083CFB68b5E8C8DFe0d773C3C2265d",
      "registryCoreAddr": "0x4d6FF88dd93b1911D2e61FA4Bbd8879cC57810dE",
      "defaultResolverAddr": "0x762db8903cc1E571Bd409D3e3a768Fc778607ebD",
      "layerZeroManagerAddr": "0xe03Ad88156aA136A266C9f8aae8Ef89720236844",
      "chainlinkAddr": "0x022F9dCC73C5Fb43F2b4eF2EF9ad3eDD1D853946"
    },
    "168587773": {
      "registarAddr": "0x01b4F12B2C05E2d7dD10cc861795dC084C1AaC58",
      "managerAddr": "0xd3493a14282871d9F625076AB7802a7405A116A9",
      "registryEndPointAddr": "0x1dDDb55B9f04EDd2822CFf77727A985C814d33Db",
      "registryCoreAddr": "0xc6438aD72Cf80CCe4c6831C093dcEaA42CD95d8C",
      "defaultResolverAddr": "0xC8Bb48Fd3568352C4AA6169D52aa042BD48702a5",
      "layerZeroManagerAddr": "0x0000000000000000000000000000000000000000",
      "chainlinkAddr": ""
    },
    "1687": {
      "registarAddr": "0x935d92E7bE9c8A30f22f7CA21d053A37a0D56542",
      "managerAddr": "0x39e752B02E473Df495FF6F8E61eA6b899E2CBb70",
      "registryEndPointAddr": "0x9Dc47E9be9Dba32480feB20d39289CE35BcF99C1",
      "registryCoreAddr": "0x51F77CDd4d0DA8AbF4714fe03358811639C1D51C",
      "defaultResolverAddr": "0x99F093467f94e65D7C70830aCb0e74b172975A3E",
      "layerZeroManagerAddr": "0x0000000000000000000000000000000000000000",
      "chainlinkAddr": ""
    },
    "919": {
      "registarAddr": "0x01b4F12B2C05E2d7dD10cc861795dC084C1AaC58",
      "managerAddr": "0xd3493a14282871d9F625076AB7802a7405A116A9",
      "registryEndPointAddr": "0x1dDDb55B9f04EDd2822CFf77727A985C814d33Db",
      "registryCoreAddr": "0xc6438aD72Cf80CCe4c6831C093dcEaA42CD95d8C",
      "defaultResolverAddr": "0xC8Bb48Fd3568352C4AA6169D52aa042BD48702a5",
      "layerZeroManagerAddr": "0x76E0c67a11Ee38C8ED6321F7FD5e122F076df535",
      "chainlinkAddr": ""
    },
    "195": {
      "registarAddr": "0xcc8734cc0A9b2B460caC997730401f614FE36c36",
      "managerAddr": "0x87784286B9Cf094382C3048C1F41e973EDC7a06a",
      "registryEndPointAddr": "0x207cE423Cade3f945b963ffAe15BE40E7eE30922",
      "registryCoreAddr": "0x01b4F12B2C05E2d7dD10cc861795dC084C1AaC58",
      "defaultResolverAddr": "0x20Eee81481faF84C872a131d19323188aa417045",
      "layerZeroManagerAddr": "0x0000000000000000000000000000000000000000",
      "chainlinkAddr": ""
    },
    "80085": {
      "registarAddr": "0xcc8734cc0A9b2B460caC997730401f614FE36c36",
      "managerAddr": "0x87784286B9Cf094382C3048C1F41e973EDC7a06a",
      "registryEndPointAddr": "0x207cE423Cade3f945b963ffAe15BE40E7eE30922",
      "registryCoreAddr": "0x1fa59909ec3bD740B1cAC991d0C3d95EeF2fCF4c",
      "defaultResolverAddr": "0x20Eee81481faF84C872a131d19323188aa417045",
      "layerZeroManagerAddr": "0x0000000000000000000000000000000000000000",
      "chainlinkAddr": ""
    }
  },
  "beta": {
    "11155111": {
      "registarAddr": "0x7D1341468b30C6c0e026A50B9177622ed4A998ab",
      "managerAddr": "0xa954DFBF52FA5F9D0851896d3ad9D8eCE36938D4",
      "registryEndPointAddr": "0x06C850B20bb2FcF7a4822F6bAaeFdbaf30a80410",
      "registryCoreAddr": "0xf7fa64e5d947FCCe11DB1eB9a32aA05E9Bab41e7",
      "defaultResolverAddr": "0x5a423F8C4f5B4e3b38A8f05FFC09a0cAb5332Fa6",
      "layerZeroManagerAddr": "0x0000000000000000000000000000000000000000",
      "chainlinkAddr": "0x694AA1769357215DE4FAC081bf1f309aDC325306"
    },
    "168587773": {
      "registarAddr": "0x935d92E7bE9c8A30f22f7CA21d053A37a0D56542",
      "managerAddr": "0x39e752B02E473Df495FF6F8E61eA6b899E2CBb70",
      "registryEndPointAddr": "0x9Dc47E9be9Dba32480feB20d39289CE35BcF99C1",
      "registryCoreAddr": "0x51F77CDd4d0DA8AbF4714fe03358811639C1D51C",
      "defaultResolverAddr": "0x99F093467f94e65D7C70830aCb0e74b172975A3E",
      "layerZeroManagerAddr": "0x0000000000000000000000000000000000000000",
      "chainlinkAddr": ""
    },
    "1687": {
      "registarAddr": "0x01b4F12B2C05E2d7dD10cc861795dC084C1AaC58",
      "managerAddr": "0xd3493a14282871d9F625076AB7802a7405A116A9",
      "registryEndPointAddr": "0x1dDDb55B9f04EDd2822CFf77727A985C814d33Db",
      "registryCoreAddr": "0xc6438aD72Cf80CCe4c6831C093dcEaA42CD95d8C",
      "defaultResolverAddr": "0xC8Bb48Fd3568352C4AA6169D52aa042BD48702a5",
      "layerZeroManagerAddr": "0x0000000000000000000000000000000000000000",
      "chainlinkAddr": ""
    },
    "80085": {
      "registarAddr": "0x8d6fF08996083CFB68b5E8C8DFe0d773C3C2265d",
      "managerAddr": "0x762db8903cc1E571Bd409D3e3a768Fc778607ebD",
      "registryEndPointAddr": "0xb0e16eb2ca8aaa2267d2c5c55F999979444b2723",
      "registryCoreAddr": "0xdde1628aB13460e3870E00EEc37782E1710593C3",
      "defaultResolverAddr": "0xe03Ad88156aA136A266C9f8aae8Ef89720236844",
      "layerZeroManagerAddr": "0x0000000000000000000000000000000000000000",
      "chainlinkAddr": ""
    }
  },
  "alpha": {
    "1": {
      "registarAddr": "0xc3DFbAfEB080b6d8A683e8bf0387Ba106733E90a",
      "managerAddr": "0x8480789707f2d6100943Fb4ab667506F7C9350E6",
      "registryEndPointAddr": "0xCfe25d36Beb66A21E5526DBaA578D26BF361c21B",
      "registryCoreAddr": "0x71cA95beAc625Aefac44C0E1559B472306E9a500",
      "defaultResolverAddr": "0x153DCd5975ACc20EC350988cf2584FdaA6c11621",
      "layerZeroManagerAddr": "0x0bfbcfbcD74478136C5257D0902bdcdCaD84DE17",
      "chainlinkAddr": "0x5f4eC3Df9cbd43714FE2740f5E3616155c5b8419"
    },
    "10": {
      "registarAddr": "0xc230FAEbED018837e057cBB72158B3B65D8352Db",
      "managerAddr": "0xFA289Cd00a6fB9207754b856f8644cf3580d2e5e",
      "registryEndPointAddr": "0x0Bc96e64Eb9Ab9944b2f95dcD7b624AC22faeFE8",
      "registryCoreAddr": "0x6EcDa16fdAabE41D095ef2Ee57D29882365A1157",
      "defaultResolverAddr": "0xBa6F623f85ae7514a036e4745fD821282E4Ae65C",
      "layerZeroManagerAddr": "0x1695ad0b804FAc32B14815ee3b5ff9eA19336CeD",
      "chainlinkAddr": "0x13e3Ee699D1909E989722E753853AE30b17e08c5"
    },
    "56": {
      "registarAddr": "0x2B333FF0a3e5A4d79B058aA91F2EC03E051EB469",
      "managerAddr": "0x45B4Ff81c758624872FC36c67a3EAC82Ac2de64c",
      "registryEndPointAddr": "0xfA4A5B6158f3AA61D9b03A124FA6073265e4dac0",
      "registryCoreAddr": "0xEA48FA5Beb8497D4fb4B319FfC772f6B1f4A5B53",
      "defaultResolverAddr": "0x177a6bbB6a322c17a67c6AfDB558923FAEF6480e",
      "layerZeroManagerAddr": "0xF90CD2C2A8E1cBe11603d3209D9d8836Ed616B16",
      "chainlinkAddr": "0x0567F2323251f0Aab15c8dFb1967E4e8A7D42aeE"
    },
    "137": {
      "registarAddr": "0x46230C6433822B0F2F956C20eB13F8224b79e316",
      "managerAddr": "0xF3a4c06E6bb34886983798D33f1A560b8774B51c",
      "registryEndPointAddr": "0xBa6F623f85ae7514a036e4745fD821282E4Ae65C",
      "registryCoreAddr": "0xFA289Cd00a6fB9207754b856f8644cf3580d2e5e",
      "defaultResolverAddr": "0x1695ad0b804FAc32B14815ee3b5ff9eA19336CeD",
      "layerZeroManagerAddr": "0x9BC581abAE727A7085d7414d769ED1c40600fDD3",
      "chainlinkAddr": "0xAB594600376Ec9fD91F8e885dADF0CE036862dE0"
    },
    "324": {
      "registarAddr": "0x1CBB2d5e2a31933f2A2Fc827f162cBb276d76ECA",
      "managerAddr": "0xC342171206eD08773f32E6BD1A377f72dD5F05f0",
      "registryEndPointAddr": "0x639cbc018EbF85c106F9D3E1161f654F88bAB703",
      "registryCoreAddr": "0xE0668eB79a22af2130E92C2e66067E51CB09F977",
      "defaultResolverAddr": "0x2185b51726dDdfDB802563e7D469752Aa038Fbf8",
      "layerZeroManagerAddr": "0xB5595891ec8884a182B008775F288469FA857d9E",
      "chainlinkAddr": ""
    },
    "8453": {
      "registarAddr": "0x7818127930aD5Ed9E83DF535D9bF9cbb7439F034",
      "managerAddr": "0xc230FAEbED018837e057cBB72158B3B65D8352Db",
      "registryEndPointAddr": "0x6EcDa16fdAabE41D095ef2Ee57D29882365A1157",
      "registryCoreAddr": "0x3A97e29994d5BFACa9a130F89072Cacc2022e998",
      "defaultResolverAddr": "0x0Bc96e64Eb9Ab9944b2f95dcD7b624AC22faeFE8",
      "layerZeroManagerAddr": "0xFA289Cd00a6fB9207754b856f8644cf3580d2e5e",
      "chainlinkAddr": "0x71041dddad3595F9CEd3DcCFBe3D1F4b0a16Bb70"
    },
    "42161": {
      "registarAddr": "0xc230FAEbED018837e057cBB72158B3B65D8352Db",
      "managerAddr": "0xFA289Cd00a6fB9207754b856f8644cf3580d2e5e",
      "registryEndPointAddr": "0x0Bc96e64Eb9Ab9944b2f95dcD7b624AC22faeFE8",
      "registryCoreAddr": "0x6EcDa16fdAabE41D095ef2Ee57D29882365A1157",
      "defaultResolverAddr": "0xBa6F623f85ae7514a036e4745fD821282E4Ae65C",
      "layerZeroManagerAddr": "0x1695ad0b804FAc32B14815ee3b5ff9eA19336CeD",
      "chainlinkAddr": "0x639Fe6ab55C921f74e7fac1ee960C0B6293ba612"
    },
    "59144": {
      "registarAddr": "0x3A97e29994d5BFACa9a130F89072Cacc2022e998",
      "managerAddr": "0x6EcDa16fdAabE41D095ef2Ee57D29882365A1157",
      "registryEndPointAddr": "0x7818127930aD5Ed9E83DF535D9bF9cbb7439F034",
      "registryCoreAddr": "0x741EF6bB7152DE81C817664d0e0AEfc1437E9ab7",
      "defaultResolverAddr": "0xc230FAEbED018837e057cBB72158B3B65D8352Db",
      "layerZeroManagerAddr": "0x0Bc96e64Eb9Ab9944b2f95dcD7b624AC22faeFE8",
      "chainlinkAddr": ""
    },
    "1101": {
      "registarAddr": "0x3A97e29994d5BFACa9a130F89072Cacc2022e998",
      "managerAddr": "0x6EcDa16fdAabE41D095ef2Ee57D29882365A1157",
      "registryEndPointAddr": "0x7818127930aD5Ed9E83DF535D9bF9cbb7439F034",
      "registryCoreAddr": "0x741EF6bB7152DE81C817664d0e0AEfc1437E9ab7",
      "defaultResolverAddr": "0xc230FAEbED018837e057cBB72158B3B65D8352Db",
      "layerZeroManagerAddr": "0x0Bc96e64Eb9Ab9944b2f95dcD7b624AC22faeFE8",
      "chainlinkAddr": ""
    },
    "43114": {
      "registarAddr": "0x01b4F12B2C05E2d7dD10cc861795dC084C1AaC58",
      "managerAddr": "0xd3493a14282871d9F625076AB7802a7405A116A9",
      "registryEndPointAddr": "0x1dDDb55B9f04EDd2822CFf77727A985C814d33Db",
      "registryCoreAddr": "0xc6438aD72Cf80CCe4c6831C093dcEaA42CD95d8C",
      "defaultResolverAddr": "0xC8Bb48Fd3568352C4AA6169D52aa042BD48702a5",
      "layerZeroManagerAddr": "0x76E0c67a11Ee38C8ED6321F7FD5e122F076df535",
      "chainlinkAddr": "0x0A77230d17318075983913bC2145DB16C7366156"
    },
    "204": {
      "registarAddr": "0xd3493a14282871d9F625076AB7802a7405A116A9",
      "managerAddr": "0x76E0c67a11Ee38C8ED6321F7FD5e122F076df535",
      "registryEndPointAddr": "0xC8Bb48Fd3568352C4AA6169D52aa042BD48702a5",
      "registryCoreAddr": "0x8665b5E1F570Bc659C6DB6A2449ea2c2f01A35aB",
      "defaultResolverAddr": "0x11e78296491d0fC071dEFa690DDBE023484Dc590",
      "layerZeroManagerAddr": "0x14bfDC548b1e64Efd7E9b4b35BE8f8b94096d740",
      "chainlinkAddr": ""
    },
    "250": {
      "registarAddr": "0x01b4F12B2C05E2d7dD10cc861795dC084C1AaC58",
      "managerAddr": "0xd3493a14282871d9F625076AB7802a7405A116A9",
      "registryEndPointAddr": "0x1dDDb55B9f04EDd2822CFf77727A985C814d33Db",
      "registryCoreAddr": "0xc6438aD72Cf80CCe4c6831C093dcEaA42CD95d8C",
      "defaultResolverAddr": "0xC8Bb48Fd3568352C4AA6169D52aa042BD48702a5",
      "layerZeroManagerAddr": "0x76E0c67a11Ee38C8ED6321F7FD5e122F076df535",
      "chainlinkAddr": "0xf4766552D15AE4d256Ad41B6cf2933482B0680dc"
    },
    "534352": {
      "registarAddr": "0x01b4F12B2C05E2d7dD10cc861795dC084C1AaC58",
      "managerAddr": "0xd3493a14282871d9F625076AB7802a7405A116A9",
      "registryEndPointAddr": "0x1dDDb55B9f04EDd2822CFf77727A985C814d33Db",
      "registryCoreAddr": "0xc6438aD72Cf80CCe4c6831C093dcEaA42CD95d8C",
      "defaultResolverAddr": "0xC8Bb48Fd3568352C4AA6169D52aa042BD48702a5",
      "layerZeroManagerAddr": "0x76E0c67a11Ee38C8ED6321F7FD5e122F076df535",
      "chainlinkAddr": ""
    },
    "1030": {
      "registarAddr": "0x01b4F12B2C05E2d7dD10cc861795dC084C1AaC58",
      "managerAddr": "0xd3493a14282871d9F625076AB7802a7405A116A9",
      "registryEndPointAddr": "0x1dDDb55B9f04EDd2822CFf77727A985C814d33Db",
      "registryCoreAddr": "0xc6438aD72Cf80CCe4c6831C093dcEaA42CD95d8C",
      "defaultResolverAddr": "0xC8Bb48Fd3568352C4AA6169D52aa042BD48702a5",
      "layerZeroManagerAddr": "0x76E0c67a11Ee38C8ED6321F7FD5e122F076df535",
      "chainlinkAddr": ""
    },
    "5000": {
      "registarAddr": "0x01b4F12B2C05E2d7dD10cc861795dC084C1AaC58",
      "managerAddr": "0xd3493a14282871d9F625076AB7802a7405A116A9",
      "registryEndPointAddr": "0x1dDDb55B9f04EDd2822CFf77727A985C814d33Db",
      "registryCoreAddr": "0xc6438aD72Cf80CCe4c6831C093dcEaA42CD95d8C",
      "defaultResolverAddr": "0xC8Bb48Fd3568352C4AA6169D52aa042BD48702a5",
      "layerZeroManagerAddr": "0x76E0c67a11Ee38C8ED6321F7FD5e122F076df535",
      "chainlinkAddr": ""
    },
    "122": {
      "registarAddr": "0x207cE423Cade3f945b963ffAe15BE40E7eE30922",
      "managerAddr": "0x20Eee81481faF84C872a131d19323188aa417045",
      "registryEndPointAddr": "0x87784286B9Cf094382C3048C1F41e973EDC7a06a",
      "registryCoreAddr": "0xcc8734cc0A9b2B460caC997730401f614FE36c36",
      "defaultResolverAddr": "0xCb5eEC95402E4dd34B99D536a6b401fEf3EF7A40",
      "layerZeroManagerAddr": "0xca5954654fBbE3856E53f629152c9594A410ca52",
      "chainlinkAddr": ""
    },
    "1088": {
      "registarAddr": "0xcc8734cc0A9b2B460caC997730401f614FE36c36",
      "managerAddr": "0x87784286B9Cf094382C3048C1F41e973EDC7a06a",
      "registryEndPointAddr": "0x207cE423Cade3f945b963ffAe15BE40E7eE30922",
      "registryCoreAddr": "0x1fa59909ec3bD740B1cAC991d0C3d95EeF2fCF4c",
      "defaultResolverAddr": "0x20Eee81481faF84C872a131d19323188aa417045",
      "layerZeroManagerAddr": "0xCb5eEC95402E4dd34B99D536a6b401fEf3EF7A40",
      "chainlinkAddr": "0xD4a5Bb03B5D66d9bf81507379302Ac2C2DFDFa6D"
    },
    "169": {
      "registarAddr": "0x01b4F12B2C05E2d7dD10cc861795dC084C1AaC58",
      "managerAddr": "0xd3493a14282871d9F625076AB7802a7405A116A9",
      "registryEndPointAddr": "0x1dDDb55B9f04EDd2822CFf77727A985C814d33Db",
      "registryCoreAddr": "0xc6438aD72Cf80CCe4c6831C093dcEaA42CD95d8C",
      "defaultResolverAddr": "0xC8Bb48Fd3568352C4AA6169D52aa042BD48702a5",
      "layerZeroManagerAddr": "0x76E0c67a11Ee38C8ED6321F7FD5e122F076df535",
      "chainlinkAddr": ""
    },
    "42220": {
      "registarAddr": "0x01b4F12B2C05E2d7dD10cc861795dC084C1AaC58",
      "managerAddr": "0xd3493a14282871d9F625076AB7802a7405A116A9",
      "registryEndPointAddr": "0x1dDDb55B9f04EDd2822CFf77727A985C814d33Db",
      "registryCoreAddr": "0xc6438aD72Cf80CCe4c6831C093dcEaA42CD95d8C",
      "defaultResolverAddr": "0xC8Bb48Fd3568352C4AA6169D52aa042BD48702a5",
      "layerZeroManagerAddr": "0x76E0c67a11Ee38C8ED6321F7FD5e122F076df535",
      "chainlinkAddr": "0x0568fD19986748cEfF3301e55c0eb1E729E0Ab7e"
    },
    "81457": {
      "registarAddr": "0x01b4F12B2C05E2d7dD10cc861795dC084C1AaC58",
      "managerAddr": "0xd3493a14282871d9F625076AB7802a7405A116A9",
      "registryEndPointAddr": "0x1dDDb55B9f04EDd2822CFf77727A985C814d33Db",
      "registryCoreAddr": "0xc6438aD72Cf80CCe4c6831C093dcEaA42CD95d8C",
      "defaultResolverAddr": "0xC8Bb48Fd3568352C4AA6169D52aa042BD48702a5",
      "layerZeroManagerAddr": "0x0000000000000000000000000000000000000000",
      "chainlinkAddr": ""
    },
    "7000": {
      "registarAddr": "0x01b4F12B2C05E2d7dD10cc861795dC084C1AaC58",
      "managerAddr": "0xd3493a14282871d9F625076AB7802a7405A116A9",
      "registryEndPointAddr": "0x1dDDb55B9f04EDd2822CFf77727A985C814d33Db",
      "registryCoreAddr": "0xc6438aD72Cf80CCe4c6831C093dcEaA42CD95d8C",
      "defaultResolverAddr": "0x20Eee81481faF84C872a131d19323188aa417045",
      "layerZeroManagerAddr": "0x0000000000000000000000000000000000000000",
      "chainlinkAddr": ""
    },
    "34443": {
      "registarAddr": "0x01b4F12B2C05E2d7dD10cc861795dC084C1AaC58",
      "managerAddr": "0xd3493a14282871d9F625076AB7802a7405A116A9",
      "registryEndPointAddr": "0x1dDDb55B9f04EDd2822CFf77727A985C814d33Db",
      "registryCoreAddr": "0xc6438aD72Cf80CCe4c6831C093dcEaA42CD95d8C",
      "defaultResolverAddr": "0xC8Bb48Fd3568352C4AA6169D52aa042BD48702a5",
      "layerZeroManagerAddr": "0x76E0c67a11Ee38C8ED6321F7FD5e122F076df535",
      "chainlinkAddr": ""
    },
    "666666666": {
      "registarAddr": "0x01b4F12B2C05E2d7dD10cc861795dC084C1AaC58",
      "managerAddr": "0xd3493a14282871d9F625076AB7802a7405A116A9",
      "registryEndPointAddr": "0x1dDDb55B9f04EDd2822CFf77727A985C814d33Db",
      "registryCoreAddr": "0xc6438aD72Cf80CCe4c6831C093dcEaA42CD95d8C",
      "defaultResolverAddr": "0xC8Bb48Fd3568352C4AA6169D52aa042BD48702a5",
      "layerZeroManagerAddr": "0x0000000000000000000000000000000000000000",
      "chainlinkAddr": ""
    },
    "7777777": {
      "registarAddr": "0xcc8734cc0A9b2B460caC997730401f614FE36c36",
      "managerAddr": "0x87784286B9Cf094382C3048C1F41e973EDC7a06a",
      "registryEndPointAddr": "0x207cE423Cade3f945b963ffAe15BE40E7eE30922",
      "registryCoreAddr": "0x1fa59909ec3bD740B1cAC991d0C3d95EeF2fCF4c",
      "defaultResolverAddr": "0x20Eee81481faF84C872a131d19323188aa417045",
      "layerZeroManagerAddr": "0xCb5eEC95402E4dd34B99D536a6b401fEf3EF7A40",
      "chainlinkAddr": ""
    },
    "196": {
      "registarAddr": "0x01b4F12B2C05E2d7dD10cc861795dC084C1AaC58",
      "managerAddr": "0xd3493a14282871d9F625076AB7802a7405A116A9",
      "registryEndPointAddr": "0x1dDDb55B9f04EDd2822CFf77727A985C814d33Db",
      "registryCoreAddr": "0xc6438aD72Cf80CCe4c6831C093dcEaA42CD95d8C",
      "defaultResolverAddr": "0xC8Bb48Fd3568352C4AA6169D52aa042BD48702a5",
      "layerZeroManagerAddr": "0x0000000000000000000000000000000000000000",
      "chainlinkAddr": ""
    }
  },
  "prod": {
    "1": {
      "registarAddr": "0x37f754953f7f22f9baf5C23a72d62Db0aFd397d0",
      "managerAddr": "0xD772Bdd55F58e12988460FBa70082eE157131467",
      "registryEndPointAddr": "0x0A94fcc76904257F80E38bee6D750978c72fdE78",
      "registryCoreAddr": "0xbC09AcF144C1B3795172c912D2b4656496178Fc0",
      "defaultResolverAddr": "0x1aE3d3a0CD9632c385a255A8d7CB19021336473f",
      "layerZeroManagerAddr": "0xB11773e63920FCbB4F2156d1a6cef11f7138793a",
      "chainlinkAddr": "0x5f4eC3Df9cbd43714FE2740f5E3616155c5b8419"
    },
    "10": {
      "registarAddr": "0x6692c24E8E30fE956badD0C707cF0a5B99e64978",
      "managerAddr": "0xC6CCA5ED53A89D29784D2b97033A93657ED470F3",
      "registryEndPointAddr": "0xA19131eCa9b0f0b91C489e6B030ad7BBB8CdBDe2",
      "registryCoreAddr": "0xA6Df73209a473DC6626DDf17e58d3B48FcfdE875",
      "defaultResolverAddr": "0xbC09AcF144C1B3795172c912D2b4656496178Fc0",
      "layerZeroManagerAddr": "0x37f754953f7f22f9baf5C23a72d62Db0aFd397d0",
      "chainlinkAddr": "0x13e3Ee699D1909E989722E753853AE30b17e08c5"
    },
    "56": {
      "registarAddr": "0x2207D1b2163669de676b83a8dDa1995d57eea658",
      "managerAddr": "0xA6Df73209a473DC6626DDf17e58d3B48FcfdE875",
      "registryEndPointAddr": "0xA76dfFB814C1DE2E5533d35197dc8b87aadc8a5f",
      "registryCoreAddr": "0x174c03Cb5287471F7766b3904328489E644606a9",
      "defaultResolverAddr": "0x6692c24E8E30fE956badD0C707cF0a5B99e64978",
      "layerZeroManagerAddr": "0xA19131eCa9b0f0b91C489e6B030ad7BBB8CdBDe2",
      "chainlinkAddr": "0x0567F2323251f0Aab15c8dFb1967E4e8A7D42aeE"
    },
    "137": {
      "registarAddr": "0x6692c24E8E30fE956badD0C707cF0a5B99e64978",
      "managerAddr": "0xC6CCA5ED53A89D29784D2b97033A93657ED470F3",
      "registryEndPointAddr": "0xA19131eCa9b0f0b91C489e6B030ad7BBB8CdBDe2",
      "registryCoreAddr": "0xA6Df73209a473DC6626DDf17e58d3B48FcfdE875",
      "defaultResolverAddr": "0xbC09AcF144C1B3795172c912D2b4656496178Fc0",
      "layerZeroManagerAddr": "0x37f754953f7f22f9baf5C23a72d62Db0aFd397d0",
      "chainlinkAddr": "0xAB594600376Ec9fD91F8e885dADF0CE036862dE0"
    },
    "324": {
      "registarAddr": "0x555e6c1b5d278217C519F99B6AF799e9A67276a9",
      "managerAddr": "0xAB649369884057AB14d210435dc952C4030C35f4",
      "registryEndPointAddr": "0x17919e9f344d6e10b814138aD4b131B697091426",
      "registryCoreAddr": "0x092Db8646AbBcc7db5a88B07a6743cc09cE87D47",
      "defaultResolverAddr": "0x67603400B42db751B00FF9613B63657759316bF1",
      "layerZeroManagerAddr": "0x4fD780337f780A62f9221e6043C4c591D02FCcBa",
      "chainlinkAddr": ""
    },
    "8453": {
      "registarAddr": "0x3AccBC1EC67c31f9d263898113b70A46f4d040f6",
      "managerAddr": "0x174c03Cb5287471F7766b3904328489E644606a9",
      "registryEndPointAddr": "0xbD345Bd36392E7bcD31Bc00bbD77601eb46b4A0B",
      "registryCoreAddr": "0xfd4E4E38819E2dB4799d0F57C70d7Ac5AA71F018",
      "defaultResolverAddr": "0x2207D1b2163669de676b83a8dDa1995d57eea658",
      "layerZeroManagerAddr": "0xA76dfFB814C1DE2E5533d35197dc8b87aadc8a5f",
      "chainlinkAddr": "0x71041dddad3595F9CEd3DcCFBe3D1F4b0a16Bb70"
    },
    "42161": {
      "registarAddr": "0x6692c24E8E30fE956badD0C707cF0a5B99e64978",
      "managerAddr": "0xC6CCA5ED53A89D29784D2b97033A93657ED470F3",
      "registryEndPointAddr": "0xA19131eCa9b0f0b91C489e6B030ad7BBB8CdBDe2",
      "registryCoreAddr": "0xA6Df73209a473DC6626DDf17e58d3B48FcfdE875",
      "defaultResolverAddr": "0xbC09AcF144C1B3795172c912D2b4656496178Fc0",
      "layerZeroManagerAddr": "0x37f754953f7f22f9baf5C23a72d62Db0aFd397d0",
      "chainlinkAddr": "0x639Fe6ab55C921f74e7fac1ee960C0B6293ba612"
    },
    "59144": {
      "registarAddr": "0x3AccBC1EC67c31f9d263898113b70A46f4d040f6",
      "managerAddr": "0x174c03Cb5287471F7766b3904328489E644606a9",
      "registryEndPointAddr": "0xbD345Bd36392E7bcD31Bc00bbD77601eb46b4A0B",
      "registryCoreAddr": "0xfd4E4E38819E2dB4799d0F57C70d7Ac5AA71F018",
      "defaultResolverAddr": "0x2207D1b2163669de676b83a8dDa1995d57eea658",
      "layerZeroManagerAddr": "0xA76dfFB814C1DE2E5533d35197dc8b87aadc8a5f",
      "chainlinkAddr": ""
    },
    "1101": {
      "registarAddr": "0xbD345Bd36392E7bcD31Bc00bbD77601eb46b4A0B",
      "managerAddr": "0x2207D1b2163669de676b83a8dDa1995d57eea658",
      "registryEndPointAddr": "0x174c03Cb5287471F7766b3904328489E644606a9",
      "registryCoreAddr": "0x3AccBC1EC67c31f9d263898113b70A46f4d040f6",
      "defaultResolverAddr": "0xA76dfFB814C1DE2E5533d35197dc8b87aadc8a5f",
      "layerZeroManagerAddr": "0xA7A16C1d8731F367a3621A3fd2728875D33EE64d",
      "chainlinkAddr": ""
    },
    "43114": {
      "registarAddr": "0x6692c24E8E30fE956badD0C707cF0a5B99e64978",
      "managerAddr": "0xC6CCA5ED53A89D29784D2b97033A93657ED470F3",
      "registryEndPointAddr": "0xA19131eCa9b0f0b91C489e6B030ad7BBB8CdBDe2",
      "registryCoreAddr": "0xA6Df73209a473DC6626DDf17e58d3B48FcfdE875",
      "defaultResolverAddr": "0xbC09AcF144C1B3795172c912D2b4656496178Fc0",
      "layerZeroManagerAddr": "0x37f754953f7f22f9baf5C23a72d62Db0aFd397d0",
      "chainlinkAddr": "0x0A77230d17318075983913bC2145DB16C7366156"
    },
    "204": {
      "registarAddr": "0xA19131eCa9b0f0b91C489e6B030ad7BBB8CdBDe2",
      "managerAddr": "0x0A94fcc76904257F80E38bee6D750978c72fdE78",
      "registryEndPointAddr": "0xC6CCA5ED53A89D29784D2b97033A93657ED470F3",
      "registryCoreAddr": "0x6692c24E8E30fE956badD0C707cF0a5B99e64978",
      "defaultResolverAddr": "0xA7A16C1d8731F367a3621A3fd2728875D33EE64d",
      "layerZeroManagerAddr": "0xD772Bdd55F58e12988460FBa70082eE157131467",
      "chainlinkAddr": ""
    },
    "250": {
      "registarAddr": "0x6692c24E8E30fE956badD0C707cF0a5B99e64978",
      "managerAddr": "0xC6CCA5ED53A89D29784D2b97033A93657ED470F3",
      "registryEndPointAddr": "0xA19131eCa9b0f0b91C489e6B030ad7BBB8CdBDe2",
      "registryCoreAddr": "0xA6Df73209a473DC6626DDf17e58d3B48FcfdE875",
      "defaultResolverAddr": "0xbC09AcF144C1B3795172c912D2b4656496178Fc0",
      "layerZeroManagerAddr": "0x37f754953f7f22f9baf5C23a72d62Db0aFd397d0",
      "chainlinkAddr": "0xf4766552D15AE4d256Ad41B6cf2933482B0680dc"
    },
    "534352": {
      "registarAddr": "0x6692c24E8E30fE956badD0C707cF0a5B99e64978",
      "managerAddr": "0xC6CCA5ED53A89D29784D2b97033A93657ED470F3",
      "registryEndPointAddr": "0xA19131eCa9b0f0b91C489e6B030ad7BBB8CdBDe2",
      "registryCoreAddr": "0xA6Df73209a473DC6626DDf17e58d3B48FcfdE875",
      "defaultResolverAddr": "0xbC09AcF144C1B3795172c912D2b4656496178Fc0",
      "layerZeroManagerAddr": "0x37f754953f7f22f9baf5C23a72d62Db0aFd397d0",
      "chainlinkAddr": ""
    },
    "1030": {
      "registarAddr": "0x6692c24E8E30fE956badD0C707cF0a5B99e64978",
      "managerAddr": "0xC6CCA5ED53A89D29784D2b97033A93657ED470F3",
      "registryEndPointAddr": "0xA19131eCa9b0f0b91C489e6B030ad7BBB8CdBDe2",
      "registryCoreAddr": "0xA6Df73209a473DC6626DDf17e58d3B48FcfdE875",
      "defaultResolverAddr": "0xbC09AcF144C1B3795172c912D2b4656496178Fc0",
      "layerZeroManagerAddr": "0x37f754953f7f22f9baf5C23a72d62Db0aFd397d0",
      "chainlinkAddr": ""
    },
    "5000": {
      "registarAddr": "0x6692c24E8E30fE956badD0C707cF0a5B99e64978",
      "managerAddr": "0xC6CCA5ED53A89D29784D2b97033A93657ED470F3",
      "registryEndPointAddr": "0xA19131eCa9b0f0b91C489e6B030ad7BBB8CdBDe2",
      "registryCoreAddr": "0xA6Df73209a473DC6626DDf17e58d3B48FcfdE875",
      "defaultResolverAddr": "0xbC09AcF144C1B3795172c912D2b4656496178Fc0",
      "layerZeroManagerAddr": "0x37f754953f7f22f9baf5C23a72d62Db0aFd397d0",
      "chainlinkAddr": ""
    },
    "122": {
      "registarAddr": "0x6692c24E8E30fE956badD0C707cF0a5B99e64978",
      "managerAddr": "0xC6CCA5ED53A89D29784D2b97033A93657ED470F3",
      "registryEndPointAddr": "0xA19131eCa9b0f0b91C489e6B030ad7BBB8CdBDe2",
      "registryCoreAddr": "0xA6Df73209a473DC6626DDf17e58d3B48FcfdE875",
      "defaultResolverAddr": "0xbC09AcF144C1B3795172c912D2b4656496178Fc0",
      "layerZeroManagerAddr": "0x37f754953f7f22f9baf5C23a72d62Db0aFd397d0",
      "chainlinkAddr": ""
    },
    "1088": {
      "registarAddr": "0x6692c24E8E30fE956badD0C707cF0a5B99e64978",
      "managerAddr": "0xC6CCA5ED53A89D29784D2b97033A93657ED470F3",
      "registryEndPointAddr": "0xA19131eCa9b0f0b91C489e6B030ad7BBB8CdBDe2",
      "registryCoreAddr": "0xA6Df73209a473DC6626DDf17e58d3B48FcfdE875",
      "defaultResolverAddr": "0xbC09AcF144C1B3795172c912D2b4656496178Fc0",
      "layerZeroManagerAddr": "0x37f754953f7f22f9baf5C23a72d62Db0aFd397d0",
      "chainlinkAddr": "0xD4a5Bb03B5D66d9bf81507379302Ac2C2DFDFa6D"
    },
    "169": {
      "registarAddr": "0x6692c24E8E30fE956badD0C707cF0a5B99e64978",
      "managerAddr": "0xC6CCA5ED53A89D29784D2b97033A93657ED470F3",
      "registryEndPointAddr": "0xA19131eCa9b0f0b91C489e6B030ad7BBB8CdBDe2",
      "registryCoreAddr": "0xA6Df73209a473DC6626DDf17e58d3B48FcfdE875",
      "defaultResolverAddr": "0xbC09AcF144C1B3795172c912D2b4656496178Fc0",
      "layerZeroManagerAddr": "0x37f754953f7f22f9baf5C23a72d62Db0aFd397d0",
      "chainlinkAddr": ""
    },
    "42220": {
      "registarAddr": "0x6692c24E8E30fE956badD0C707cF0a5B99e64978",
      "managerAddr": "0xC6CCA5ED53A89D29784D2b97033A93657ED470F3",
      "registryEndPointAddr": "0xA19131eCa9b0f0b91C489e6B030ad7BBB8CdBDe2",
      "registryCoreAddr": "0xA6Df73209a473DC6626DDf17e58d3B48FcfdE875",
      "defaultResolverAddr": "0xbC09AcF144C1B3795172c912D2b4656496178Fc0",
      "layerZeroManagerAddr": "0x37f754953f7f22f9baf5C23a72d62Db0aFd397d0",
      "chainlinkAddr": "0x0568fD19986748cEfF3301e55c0eb1E729E0Ab7e"
    },
    "81457": {
      "registarAddr": "0x6692c24E8E30fE956badD0C707cF0a5B99e64978",
      "managerAddr": "0xC6CCA5ED53A89D29784D2b97033A93657ED470F3",
      "registryEndPointAddr": "0xA19131eCa9b0f0b91C489e6B030ad7BBB8CdBDe2",
      "registryCoreAddr": "0xA6Df73209a473DC6626DDf17e58d3B48FcfdE875",
      "defaultResolverAddr": "0xbC09AcF144C1B3795172c912D2b4656496178Fc0",
      "layerZeroManagerAddr": "0x37f754953f7f22f9baf5C23a72d62Db0aFd397d0",
      "chainlinkAddr": ""
    },
    "34443": {
      "registarAddr": "0x6692c24E8E30fE956badD0C707cF0a5B99e64978",
      "managerAddr": "0xC6CCA5ED53A89D29784D2b97033A93657ED470F3",
      "registryEndPointAddr": "0xA19131eCa9b0f0b91C489e6B030ad7BBB8CdBDe2",
      "registryCoreAddr": "0xA6Df73209a473DC6626DDf17e58d3B48FcfdE875",
      "defaultResolverAddr": "0xbC09AcF144C1B3795172c912D2b4656496178Fc0",
      "layerZeroManagerAddr": "0x37f754953f7f22f9baf5C23a72d62Db0aFd397d0",
      "chainlinkAddr": ""
    },
    "666666666": {
      "registarAddr": "0x3AccBC1EC67c31f9d263898113b70A46f4d040f6",
      "managerAddr": "0x174c03Cb5287471F7766b3904328489E644606a9",
      "registryEndPointAddr": "0xbD345Bd36392E7bcD31Bc00bbD77601eb46b4A0B",
      "registryCoreAddr": "0xfd4E4E38819E2dB4799d0F57C70d7Ac5AA71F018",
      "defaultResolverAddr": "0x2207D1b2163669de676b83a8dDa1995d57eea658",
      "layerZeroManagerAddr": "0x0000000000000000000000000000000000000000",
      "chainlinkAddr": ""
    },
    "7777777": {
      "registarAddr": "0x6692c24E8E30fE956badD0C707cF0a5B99e64978",
      "managerAddr": "0xC6CCA5ED53A89D29784D2b97033A93657ED470F3",
      "registryEndPointAddr": "0xA19131eCa9b0f0b91C489e6B030ad7BBB8CdBDe2",
      "registryCoreAddr": "0xA6Df73209a473DC6626DDf17e58d3B48FcfdE875",
      "defaultResolverAddr": "0xbC09AcF144C1B3795172c912D2b4656496178Fc0",
      "layerZeroManagerAddr": "0x0A94fcc76904257F80E38bee6D750978c72fdE78",
      "chainlinkAddr": ""
    },
    "196": {
      "registarAddr": "0x6692c24E8E30fE956badD0C707cF0a5B99e64978",
      "managerAddr": "0xC6CCA5ED53A89D29784D2b97033A93657ED470F3",
      "registryEndPointAddr": "0xA19131eCa9b0f0b91C489e6B030ad7BBB8CdBDe2",
      "registryCoreAddr": "0xA6Df73209a473DC6626DDf17e58d3B48FcfdE875",
      "defaultResolverAddr": "0xbC09AcF144C1B3795172c912D2b4656496178Fc0",
      "layerZeroManagerAddr": "0x0000000000000000000000000000000000000000",
      "chainlinkAddr": ""
    }
  }
};
exports.contractAddrs = contractAddrs;
var rpcUrls = {
  "testnet": {},
  "mainnet": {}
};
exports.rpcUrls = rpcUrls;
var envNetworks = {
  "env": "testnet",
  "dev": "testnet",
  "test": "testnet",
  "spec": "testnet",
  "beta": "testnet",
  "alpha": "mainnet",
  "prod": "mainnet"
}; // support chain's coin type

exports.envNetworks = envNetworks;
var ETH_COIN_TYPE_LIST = [60, 9001, 614, 966, 714, 804];
exports.ETH_COIN_TYPE_LIST = ETH_COIN_TYPE_LIST;
var ONE_DAY_SECONDS = 24 * 60 * 60;
var GRACE_PERIOD_SECONDS = 90 * ONE_DAY_SECONDS;
exports.GRACE_PERIOD_SECONDS = GRACE_PERIOD_SECONDS;
var AUCTION_PERIOD_SECONDS = 21 * ONE_DAY_SECONDS;
exports.AUCTION_PERIOD_SECONDS = AUCTION_PERIOD_SECONDS;